module.exports = __webpack_public_path__ + "img/home_jd_s_icon.e068ce5.png";